// Avoid numbers which are not multiples of 5
export const SCROLLING_TRACKING_STEPS = 20;

export const INDICATOR_PROGRESS_CSS_PROP_NAME = "--lk-p-vertical-scroll-indicator-progress";
